import { SharedState } from '../interfaces/state/shared-state';

export const sharedInitialState: SharedState = {
    loading: false,
    notification: {
        visible: false,
        message: '',
    },
} as SharedState;
